export const PRACTICE_STATUS = {
  IN_ATTESA_PRESA_IN_CARICO: 'in_attesa_presa_in_carico',
  IN_LAVORAZIONE: 'in_lavorazione',
  DA_INTEGRARE: 'da_integrare',
  COMPLETATA_IN_COMITATO: 'completata_in_comitato',
  RIFIUTATA: 'rifiutata',
  KO: 'ko',
};

export const PRACTICE_STATUS_LABELS = {
  [PRACTICE_STATUS.IN_ATTESA_PRESA_IN_CARICO]: 'In attesa',
  [PRACTICE_STATUS.IN_LAVORAZIONE]: 'In lavorazione',
  [PRACTICE_STATUS.DA_INTEGRARE]: 'Da integrare',
  [PRACTICE_STATUS.COMPLETATA_IN_COMITATO]: 'Completata',
  [PRACTICE_STATUS.RIFIUTATA]: 'Rifiutata',
  [PRACTICE_STATUS.KO]: 'KO',
};

export const USER_ROLES = {
  ADMIN: 'admin',
  SEGNALATORE: 'segnalatore',
  UFFICIO_TECNICO: 'ufficio_tecnico',
  CLIENTE: 'cliente',
};

export const ATTACHMENT_TYPES = {
  ESTRATTO_MAPPA: 'estratto_mappa',
  FILE_KMZ: 'file_kmz',
  FILE_DWG: 'file_dwg',
  ALLEGATO_GENERICO: 'allegato_generico',
  REPORT_TECNICO: 'report_tecnico',
  PLANIMETRIA: 'planimetria',
  PRODUZIONE: 'produzione',
  ANALISI_VINCOLISTICA: 'analisi_vincolistica',
  MESSAGGIO_ALLEGATO: 'messaggio_allegato',
};
